import { motion } from "framer-motion";
import { ArrowRight, Search } from "lucide-react";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_35e41a85-229a-4de7-8848-5c7e95b2544d/artifacts/kj18x3g5_F5D435F9-1C09-467E-A298-48911900093F.png";

export const Hero = ({ onOpenEncontrar, onOpenAnunciar }) => {
  return (
    <section
      id="hero"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background collage */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMG}
          alt="Parceria Certa Imobiliária"
          className="w-full h-full object-cover object-center slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1A3A] via-[#0B1A3A]/85 to-[#0B1A3A]/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1A3A]/60 via-transparent to-[#0B1A3A]" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 md:px-12 lg:px-16 relative z-10 pt-28 pb-16">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex items-center gap-4 mb-8"
          >
            <div className="gold-divider" />
            <span className="eyebrow">Locação não residencial</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
            className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-[5.2rem] leading-[1.02] text-[#F5F1EA] mb-8"
            data-testid="hero-title"
          >
            Conectamos imóveis comerciais ao{" "}
            <span className="italic gold-text">inquilino certo</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.55 }}
            className="text-[#A2AAC2] text-base md:text-lg leading-relaxed mb-12 max-w-2xl font-light"
            data-testid="hero-subtitle"
          >
            Com estratégia, agilidade e segurança em cada etapa da negociação. Especialistas em
            locação comercial, corporativa e industrial.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.75 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <button
              onClick={onOpenEncontrar}
              className="btn-gold group"
              data-testid="hero-encontrar-btn"
            >
              <Search size={16} strokeWidth={1.5} />
              Encontrar Imóvel
            </button>
            <button
              onClick={onOpenAnunciar}
              className="btn-outline-gold group"
              data-testid="hero-anunciar-btn"
            >
              Anunciar Meu Imóvel
              <ArrowRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
            </button>
          </motion.div>

          {/* Stats strip */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1 }}
            className="mt-20 grid grid-cols-3 gap-6 md:gap-12 max-w-xl border-t border-[#D4B366]/20 pt-8"
          >
            {[
              { n: "100%", l: "Foco B2B" },
              { n: "3 segmentos", l: "Comercial · Corp · Industrial" },
              { n: "Consultiva", l: "Negociação guiada" },
            ].map((s, i) => (
              <div key={i} className="flex flex-col" data-testid={`hero-stat-${i}`}>
                <span className="font-display text-xl md:text-2xl text-[#E8C97A] mb-1">{s.n}</span>
                <span className="text-[0.68rem] md:text-xs text-[#A2AAC2] tracking-[0.18em] uppercase leading-snug">
                  {s.l}
                </span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.4 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2"
      >
        <span className="text-[0.62rem] tracking-[0.32em] text-[#A2AAC2] uppercase">Role</span>
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-[1px] h-10 bg-gradient-to-b from-[#D4B366] to-transparent"
        />
      </motion.div>
    </section>
  );
};
